<template>
  <el-form-item
    v-if="visible"
    :label="$t('lang.旋转速度') + '：'">
    <el-select
      v-if="isAir"
      disabled
      :placeholder="$t('lang.请选择')"
      value="" />
    <el-select
      v-else
      :disabled="disabled"
      @change="handleChange"
      default-first-option
      :placeholder="$t('lang.请选择')"
      filterable
      v-model="localValue">
      <template v-if="devMode">
        <el-option
          v-for="r in rotateSpeedOptions"
          :key="'rotateSpeed_' + r"
          :label="r"
          :value="r" />
      </template>
    </el-select>
  </el-form-item>
</template>

<script>
const FIXED_SPEED_MODES_8097 = [
  'SM_FERMENTED_DOUGH',
  'SM_MELT_CHOCOLATE',
  'SM_GLACE_FRUIT',
  'SM_STEWED',
  'SM_NOURISHING_SOUP',
  'SM_SLOW_COOK',
  'SM_BOIL_WATER'
];

export default {
  name: 'RotateSpeed',
  props: {
    // v-model 绑定的值
    value: {
      type: [Number, String],
      default: null
    },
    devMode: {
      type: Object,
      default: null
    },
    permissions: {
      type: Array,
      default: () => []
    },
    isAir: {
      type: Boolean,
      default: false
    },
    getMotorGearCount: {
      type: Function,
      required: true
    },
    // 当前旋转方向值，用于计算选项
    rotateDirection: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    visible() {
      return this.permissions.includes('ROTATE_SPEED');
    },
    disabled() {
      if (this.isAir) return true;
      if (!this.permissions.includes('ROTATE_SPEED')) return true;
      if (this.is8097FixedSpeedMode) return true;
      return !this.devMode?.motorGearChange;
    },
    isOnly8097() {
      const selectedProducts = this.$store.state.recipe?.products || [];
      if (selectedProducts.length !== 1) return false;
      const productList = this.$store.state.brandOwnerProduct || [];
      return productList.some(product =>
        product.productCode === selectedProducts[0] && product.productModel === '8097'
      );
    },
    is8097FixedSpeedMode() {
      return this.isOnly8097 && FIXED_SPEED_MODES_8097.includes(this.devMode?.mode);
    },
    motorGearCount() {
      if (!this.devMode) return 0;
      return this.getMotorGearCount(this.devMode);
    },
    rotateSpeedOptions() {
      if (this.is8097FixedSpeedMode) return [0];
      if (!this.devMode) return [];
      const options = [];
      const count = this.motorGearCount;
      for (let r = 1; r <= count; r++) {
        if ((r - 1) >= this.devMode.minMotorGear) {
          options.push(r - 1);
        }
      }
      return options;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    is8097FixedSpeedMode: {
      immediate: true,
      handler() {
        this.set8097RotateSpeed();
      }
    },
    value() {
      this.set8097RotateSpeed();
    }
  },
  methods: {
    set8097RotateSpeed() {
      if (this.is8097FixedSpeedMode && this.value !== 0 && this.value !== '0') {
        this.$emit('input', 0);
      }
    },
    handleChange() {
      this.$emit('change');
    }
  }
};
</script>
